export const SCHEDULE_TYPES = {
  time: 'time',
  grid: 'grid',
  cl: 'CL',
};
